import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { VoiceMailDropEventPublisher } from './voice-mail-drop.usecase';

export type VoiceMailDropOutput = { success: boolean };
export class VoiceMailDropPublisher implements VoiceMailDropEventPublisher {
  private logger: Logger;

  constructor() {
    this.logger = new Logger();
  }

  async publish(
    call_sid: string,
    prerecorded_message_id: string,
  ): Promise<VoiceMailDropOutput> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'API.VOICEMAIL_DROP',
      payload: {
        call_sid,
        prerecorded_message_id,
      },
    };

    this.logger.info('Publisher: VoiceMailDrop API Call', {
      action: 'API.VOICEMAIL_DROP',
      payload: busEvent.payload,
    });

    try {
      const result = (await BusEventsPromisifier.promisifySyncEvent({
        event: busEvent,
        fulfilled: 'API.VOICEMAIL_DROP_FULFILLED',
        rejected: 'API.VOICEMAIL_DROP_REJECTED',
        target: busIframe,
      })) as VoiceMailDropOutput;

      this.logger.info('Publisher: VoiceMailDrop fulfilled', {
        result,
      });
      return result;
    } catch (error) {
      this.logger.error('Publisher: VoiceMailDrop Rejected', {
        error,
      });
      throw error;
    }
  }
}
